"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
const http_client_1 = require("./http-client");
class Api extends http_client_1.HttpClient {
    /**
* No description
*
* @tags securiry
* @name Authorize1
* @request POST:/api/loginService/authorize
*/
    authorize1 = (data, params = {}) => this.request({
        path: `/api/loginService/authorize`,
        method: 'POST',
        body: data, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ChangePassword1
* @request POST:/api/loginService/changePassword
* @secure
*/
    changePassword1 = (data, params = {}) => this.request({
        path: `/api/loginService/changePassword`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name CheckPermissions1
* @request POST:/api/loginService/checkPermissions
* @secure
*/
    checkPermissions1 = (data, params = {}) => this.request({
        path: `/api/loginService/checkPermissions`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name CreateGroup1
* @request POST:/api/principalsService/createGroup
* @secure
*/
    createGroup1 = (data, params = {}) => this.request({
        path: `/api/principalsService/createGroup`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name CreateMembership1
* @request POST:/api/principalsService/createMembership
* @secure
*/
    createMembership1 = (data, params = {}) => this.request({
        path: `/api/principalsService/createMembership`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name CreatePermission1
* @request POST:/api/policyService/createPermission
* @secure
*/
    createPermission1 = (data, params = {}) => this.request({
        path: `/api/policyService/createPermission`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name CreateRole1
* @request POST:/api/principalsService/createRole
* @secure
*/
    createRole1 = (data, params = {}) => this.request({
        path: `/api/principalsService/createRole`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name CreateSecurityProfile1
* @request POST:/api/securityProfileService/createSecurityProfile
* @secure
*/
    createSecurityProfile1 = (data, params = {}) => this.request({
        path: `/api/securityProfileService/createSecurityProfile`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name CreateUser1
* @request POST:/api/principalsService/createUser
* @secure
*/
    createUser1 = (data, params = {}) => this.request({
        path: `/api/principalsService/createUser`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name CreateUserInfo1
* @request POST:/api/dbUserManagementService/createUserInfo
* @secure
*/
    createUserInfo1 = (data, params = {}) => this.request({
        path: `/api/dbUserManagementService/createUserInfo`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ExtAuth1
* @request POST:/api/adminSecurityService/extAuth
* @secure
*/
    extAuth1 = (data, params = {}) => this.request({
        path: `/api/adminSecurityService/extAuth`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ForgetSession1
* @request POST:/api/loginService/forgetSession
* @secure
*/
    forgetSession1 = (data, params = {}) => this.request({
        path: `/api/loginService/forgetSession`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GeneratePassword1
* @request POST:/api/securityProfileService/generatePassword
* @secure
*/
    generatePassword1 = (data, params = {}) => this.request({
        path: `/api/securityProfileService/generatePassword`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetAllEndpoints
* @request POST:/api/policyService/getAllEndpoints
* @secure
*/
    getAllEndpoints = (data, params = {}) => this.request({
        path: `/api/policyService/getAllEndpoints`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetAuthInfo1
* @request POST:/api/principalsService/getAuthInfo
* @secure
*/
    getAuthInfo1 = (data, params = {}) => this.request({
        path: `/api/principalsService/getAuthInfo`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetChallenge1
* @request POST:/api/loginService/getChallenge
*/
    getChallenge1 = (data, params = {}) => this.request({
        path: `/api/loginService/getChallenge`,
        method: 'POST',
        body: data, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetGroups1
* @request POST:/api/principalsService/getGroups
* @secure
*/
    getGroups1 = (data, params = {}) => this.request({
        path: `/api/principalsService/getGroups`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetMemberships1
* @request POST:/api/principalsService/getMemberships
* @secure
*/
    getMemberships1 = (data, params = {}) => this.request({
        path: `/api/principalsService/getMemberships`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetPermissions1
* @request POST:/api/policyService/getPermissions
* @secure
*/
    getPermissions1 = (data, params = {}) => this.request({
        path: `/api/policyService/getPermissions`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetRoles1
* @request POST:/api/principalsService/getRoles
* @secure
*/
    getRoles1 = (data, params = {}) => this.request({
        path: `/api/principalsService/getRoles`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetSecurityProfiles1
* @request POST:/api/securityProfileService/getSecurityProfiles
* @secure
*/
    getSecurityProfiles1 = (data, params = {}) => this.request({
        path: `/api/securityProfileService/getSecurityProfiles`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetUserInfos1
* @request POST:/api/dbUserManagementService/getUserInfos
* @secure
*/
    getUserInfos1 = (data, params = {}) => this.request({
        path: `/api/dbUserManagementService/getUserInfos`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name GetUsers1
* @request POST:/api/principalsService/getUsers
* @secure
*/
    getUsers1 = (data, params = {}) => this.request({
        path: `/api/principalsService/getUsers`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name LockUser1
* @request POST:/api/principalsService/lockUser
* @secure
*/
    lockUser1 = (data, params = {}) => this.request({
        path: `/api/principalsService/lockUser`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ModifyGroup1
* @request POST:/api/principalsService/modifyGroup
* @secure
*/
    modifyGroup1 = (data, params = {}) => this.request({
        path: `/api/principalsService/modifyGroup`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ModifyMembershipData1
* @request POST:/api/principalsService/modifyMembershipData
* @secure
*/
    modifyMembershipData1 = (data, params = {}) => this.request({
        path: `/api/principalsService/modifyMembershipData`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ModifyPermission1
* @request POST:/api/policyService/modifyPermission
* @secure
*/
    modifyPermission1 = (data, params = {}) => this.request({
        path: `/api/policyService/modifyPermission`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ModifyRole1
* @request POST:/api/principalsService/modifyRole
* @secure
*/
    modifyRole1 = (data, params = {}) => this.request({
        path: `/api/principalsService/modifyRole`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ModifySecurityProfile1
* @request POST:/api/securityProfileService/modifySecurityProfile
* @secure
*/
    modifySecurityProfile1 = (data, params = {}) => this.request({
        path: `/api/securityProfileService/modifySecurityProfile`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ModifyUser1
* @request POST:/api/principalsService/modifyUser
* @secure
*/
    modifyUser1 = (data, params = {}) => this.request({
        path: `/api/principalsService/modifyUser`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name ModifyUserInfo1
* @request POST:/api/dbUserManagementService/modifyUserInfo
* @secure
*/
    modifyUserInfo1 = (data, params = {}) => this.request({
        path: `/api/dbUserManagementService/modifyUserInfo`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name PasswordReset1
* @request POST:/api/loginService/passwordReset
* @secure
*/
    passwordReset1 = (data, params = {}) => this.request({
        path: `/api/loginService/passwordReset`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name PasswordResetProcessSecretAnswer1
* @request POST:/api/loginService/passwordResetProcessSecretAnswer
* @secure
*/
    passwordResetProcessSecretAnswer1 = (data, params = {}) => this.request({
        path: `/api/loginService/passwordResetProcessSecretAnswer`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name PasswordResetRequestSecretQuestion1
* @request POST:/api/loginService/passwordResetRequestSecretQuestion
* @secure
*/
    passwordResetRequestSecretQuestion1 = (data, params = {}) => this.request({
        path: `/api/loginService/passwordResetRequestSecretQuestion`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name RemoveGroup1
* @request POST:/api/principalsService/removeGroup
* @secure
*/
    removeGroup1 = (data, params = {}) => this.request({
        path: `/api/principalsService/removeGroup`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name RemoveMembership1
* @request POST:/api/principalsService/removeMembership
* @secure
*/
    removeMembership1 = (data, params = {}) => this.request({
        path: `/api/principalsService/removeMembership`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name RemovePermissionId1
* @request POST:/api/policyService/removePermissionId
* @secure
*/
    removePermissionId1 = (data, params = {}) => this.request({
        path: `/api/policyService/removePermissionId`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name RemoveRole1
* @request POST:/api/principalsService/removeRole
* @secure
*/
    removeRole1 = (data, params = {}) => this.request({
        path: `/api/principalsService/removeRole`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name RemoveSecurityProfile1
* @request POST:/api/securityProfileService/removeSecurityProfile
* @secure
*/
    removeSecurityProfile1 = (data, params = {}) => this.request({
        path: `/api/securityProfileService/removeSecurityProfile`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name RemoveUser1
* @request POST:/api/principalsService/removeUser
* @secure
*/
    removeUser1 = (data, params = {}) => this.request({
        path: `/api/principalsService/removeUser`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name RemoveUserInfo1
* @request POST:/api/dbUserManagementService/removeUserInfo
* @secure
*/
    removeUserInfo1 = (data, params = {}) => this.request({
        path: `/api/dbUserManagementService/removeUserInfo`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags util
* @name SendMail1
* @request POST:/api/messengerService/sendMail
* @secure
*/
    sendMail1 = (data, params = {}) => this.request({
        path: `/api/messengerService/sendMail`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name SetPasswordResetInfo1
* @request POST:/api/loginService/setPasswordResetInfo
* @secure
*/
    setPasswordResetInfo1 = (data, params = {}) => this.request({
        path: `/api/loginService/setPasswordResetInfo`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags securiry
* @name UnlockUser1
* @request POST:/api/principalsService/unlockUser
* @secure
*/
    unlockUser1 = (data, params = {}) => this.request({
        path: `/api/principalsService/unlockUser`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags util
* @name XalanTransform1
* @request POST:/api/utilService/xalanTransform
* @secure
*/
    xalanTransform1 = (data, params = {}) => this.request({
        path: `/api/utilService/xalanTransform`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags util
* @name XsltTransform1
* @request POST:/api/utilService/xsltTransform
* @secure
*/
    xsltTransform1 = (data, params = {}) => this.request({
        path: `/api/utilService/xsltTransform`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
}
exports.Api = Api;
//# sourceMappingURL=Api.js.map